import React from 'react';

function getItemKey(item) {
    if (item?.itemKind) {
        return `${item.itemKind}:${item.id}`;
    }
    return String(item.id);
}

const KIND_LABELS = {
    code: "코드",
    text: "텍스트",
    field: "필드",
};

function SidebarFlatList({
    items = [],
    selectedItemId,
    selectedItemKey,
    onSelect,
    showItemKind = false,
}) {
    if (!items.length) {
        return null;
    }

    return (
        <ul className="sidebar-flat-list">
            {items.map((item) => {
                const itemKey = getItemKey(item);
                const isSelected = selectedItemKey
                    ? selectedItemKey === itemKey
                    : selectedItemId === item.id;

                return (
                    <li
                        key={itemKey}
                        className={`sidebar-flat-list__item ${isSelected ? "is-selected" : ""}`}
                    >
                        <button
                            type="button"
                            className="sidebar-flat-list__label"
                            onClick={() => onSelect(item)}
                        >
                            <span className="sidebar-flat-list__name">{item.name}</span>
                            {showItemKind && item.itemKind && (
                                <span className={`sidebar-flat-list__kind is-${item.itemKind}`}>
                                    {KIND_LABELS[item.itemKind] ?? item.itemKind}
                                </span>
                            )}
                        </button>
                    </li>
                );
            })}
        </ul>
    );
}

export default SidebarFlatList;
